<template>
  <div>
    <Top></Top>
    <router-view style="min-height: 100%;"/>
    <!-- 消息提示 -->
    <PopUpPrompt ref="PopUpPrompt"></PopUpPrompt>
  </div>
</template>
  
  <script>
import Top from "../components/top.vue";
import PopUpPrompt from '@/components/PopUpPrompt.vue'
export default {
  components: { Top ,PopUpPrompt},
  
};
</script>
 